module.exports = __webpack_public_path__ + "image-8d7f572d909b.png";